export default __webpack_public_path__ + "static/media/35.0f89cb1e.jpg";